import React from 'react'
import PropTypes from 'prop-types'
import { getBonusData } from '~helpers/getters.mjs'
import useTranslate from '~hooks/useTranslate/useTranslate'
import CtaButton from '../../../atoms/button/operator-cta'
import styles from './bonus-box.module.scss'
import PrettyLink from '~atoms/pretty-link'
import VariableComponent from '../variables'

export default function BonusBox({
  item,
  tracker,
  ctaBtn = true,
  welcomeBonus = true,
  pageTemplate = null,
  showVariablesComponent = true,
  variableInsideContainer = false,
  splitBy = '+',
  feSeparator = '+',
  buttonType = 'primary',
  buttonSize = 'm',
  moduleName = null,
  clickedElement = "bonusBox",
  titleSuffix,
  modulePosition,
  itemPosition
}) {
  const welcomeBonusTranslation = useTranslate('welcome_bonus', 'Welcome Bonus')
  const data = getBonusData(item, tracker, splitBy)

  const content = () => (
    <PrettyLink
      operator={item}
      pageTemplate={pageTemplate}
      moduleName={moduleName}
      tracker={tracker}
      titleSuffix={titleSuffix}
      clickedElement={clickedElement}
      className={`${styles.detailsBox} ${'bonus-box-gtm'}`}
      modulePosition={modulePosition}
      itemPosition={itemPosition}
    >
      {welcomeBonus && <p>{welcomeBonusTranslation}</p>}
      {data?.mainLine && (
        <span className={styles.firstPart}>{data.mainLine}</span>
      )}
      {data?.secondLine && (
        <span
          className={styles.secondPart}
        >{`${feSeparator}${data.secondLine}`}</span>
      )}
    </PrettyLink>
  )

  return (
    <div
      className={`${styles.bonusBox} ${showVariablesComponent ? styles.includeVariableComponent : ''
        }`}
    >
      {!showVariablesComponent ? (
        <>
          {content()}
          {ctaBtn && (
            <CtaButton
              operator={item}
              buttonType={buttonType}
              moduleName={moduleName}
              clickedElement={`${clickedElement}_cta`}
              modulePosition={modulePosition}
              itemPosition={itemPosition}
            />
          )}
        </>
      ) : (
        <div>
          {content()}
          {ctaBtn && (
            <CtaButton
              operator={item}
              buttonType={buttonType}
              buttonSize={buttonSize}
              moduleName={moduleName}
              clickedElement={`${clickedElement}_cta`}
              modulePosition={modulePosition}
              itemPosition={itemPosition}
            />
          )}
          {showVariablesComponent && variableInsideContainer && (
            <VariableComponent
              item={item}
              moduleName={moduleName}
              clickedElement={`${clickedElement}_cta`}
              modulePosition={modulePosition}
              itemPosition={itemPosition}
            />
          )}
        </div>
      )}

      {showVariablesComponent && !variableInsideContainer && (
        <VariableComponent item={item} moduleName={moduleName} modulePosition={modulePosition}
          itemPosition={itemPosition} clickedElement={clickedElement} />
      )}
    </div>
  )
}

BonusBox.propTypes = {
  item: PropTypes.shape({}),
  tracker: PropTypes.string,
  ctaBtn: PropTypes.bool,
  welcomeBonus: PropTypes.bool,
  pageTemplate: PropTypes.string,
  showVariablesComponent: PropTypes.bool,
  splitBy: PropTypes.string,
  feSeparator: PropTypes.string,
  buttonType: PropTypes.string,
  buttonSize: PropTypes.string,
  variableInsideContainer: PropTypes.bool,
  moduleName: PropTypes.string,
  clickedElement: PropTypes.string,
  titleSuffix: PropTypes.string,
  modulePosition: PropTypes.number,
  itemPosition: PropTypes.number,
}
